import config from 'src/config';
import api from 'src/services/httpService';
import storage from 'src/storage';

const Wallet = {
  axiosConfig: {
    headers: {
      Authorization: `Bearer ${storage.getToken()}`
    }
  },

  getAllWalletWithdrawals: () => {
    // console.log(axiosConfig);
    return api
      .get(`${config.rootUrl}/admin/wallet/withdrawals`, Wallet.axiosConfig)
      .then(({ data }) => data);
  },

  getAllWalletTransactions: query => {
    // console.log(axiosConfig);
    const tempConfig = Wallet.axiosConfig;
    tempConfig.params = query;
    return api
      .get(`${config.rootUrl}/admin/wallet/transactions?`, tempConfig)
      .then(({ data }) => data);
  }
};

export default Wallet;
